import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { formatAmountCurrency } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';
import { getFreeFacialValueProposals } from '../../../../utils/freeFacialValueUtils';

import './EbonSelectorPickerComponentStyle.scss';

const EbonSelectorPickerComponent = ({
    ebons,
    selectedEbon,
    setSelectedEbon,
    error,
    setError,
    inputValue,
    setInputValue,
    disable,
    i18n
}) => {
    const { availabilityResponses } = ebons;

    const hasFacialValues = ebons.availabilityResponses.length > 0;
    const hasFreeFacial = ebons.freeFacialValue !== undefined;
    const freeFacialConfig = hasFreeFacial ? ebons.freeFacialValue : null;

    const fixedValues = !hasFreeFacial
        ? availabilityResponses
        : getFreeFacialValueProposals(availabilityResponses, freeFacialConfig);

    const isEbonAvalaible = ebon => {
        // en valeur libre, un montant n'est jamais épuisé : le bon est généré à la demande
        if (hasFreeFacial || (ebon.quantityAvailable > 0 && ebon.expirationDate > 0)) {
            return true;
        }
        return false;
    };

    useEffect(() => {
        if (hasFreeFacial) {
            validateValue(inputValue);
        }
    }, [inputValue]);

    const validateValue = input => {
        const regex = /^[0-9]*\.?[0-9]*$/; // Autorise les chiffres et un point

        if (!regex.test(input)) {
            setError(i18n.ERROR_VALUE);
        } else {
            const num = parseFloat(input);
            if (num < freeFacialConfig.minimum || num > freeFacialConfig.maximum) {
                setError(
                    convertHtmlToReactDomWithParams(
                        i18n.ERROR_RANGE_VALUES,
                        formatAmountCurrency(freeFacialConfig.minimum),
                        formatAmountCurrency(freeFacialConfig.maximum)
                    )
                );
            } else {
                setError('');
            }
        }
    };

    const handleInputChange = e => {
        const value = e.target.value;
        if (value && !isNaN(value)) {
            const hasDecimals = !Number.isInteger(Number(value));
            let amount = value;
            if (!freeFacialConfig.centsAllowed && hasDecimals) {
                amount = Math.round(value);
            }

            const ebon = { facialValue: amount, quantityAvailable: 1, expirationDate: 0 };
            setInputValue(amount);
            setSelectedEbon(ebon);
        } else {
            setInputValue('');
            setSelectedEbon({});
        }
    };

    return (
        <div id="selector-picker-container">
            {!hasFreeFacial && !hasFacialValues && (
                <p className="no-availability">
                    <b>{i18n.NO_EBON_AVAILABILITY}</b>
                </p>
            )}

            {hasFreeFacial && (
                <div>
                    <div className="freeValues">
                        <label>{i18n.AMOUNT}</label>
                        <input
                            name="value"
                            className="input"
                            autoComplete="off"
                            role="spinbutton"
                            aria-valuemin={freeFacialConfig.minimum}
                            aria-valuemax={freeFacialConfig.maximum}
                            aria-valuenow={inputValue}
                            placeholder={convertHtmlToReactDomWithParams(
                                i18n.AMOUNT_RANGE,
                                formatAmountCurrency(freeFacialConfig.minimum),
                                formatAmountCurrency(freeFacialConfig.maximum)
                            )}
                            value={inputValue}
                            onChange={handleInputChange}
                            disabled={disable}
                        />
                        <div className="symbol">
                            <span>€</span>
                        </div>
                    </div>
                    {error && <p className="error">{error}</p>}
                </div>
            )}

            <div className="fixedValues">
                {fixedValues &&
                    fixedValues
                        .sort((a, b) => a.facialValue - b.facialValue)
                        .map(ebon => (
                            <button
                                key={ebon.facialValue}
                                className={`button-ebon ${
                                    selectedEbon.facialValue === ebon.facialValue ? 'selected' : ''
                                }`}
                                aria-pressed={selectedEbon.facialValue === ebon.facialValue}
                                onClick={() => {
                                    if (selectedEbon.facialValue === ebon.facialValue) {
                                        setInputValue('');
                                        setSelectedEbon({});
                                    } else {
                                        setInputValue(ebon.facialValue);
                                        setSelectedEbon(ebon);
                                    }
                                }}
                                disabled={!isEbonAvalaible(ebon) || disable}>
                                <p className="value">{formatAmountCurrency(ebon.facialValue)}</p>
                                {!isEbonAvalaible(ebon) && (
                                    <p className="soldOut">{i18n.SOLD_OUT}</p>
                                )}
                            </button>
                        ))}
            </div>
        </div>
    );
};

EbonSelectorPickerComponent.propTypes = {
    ebons: PropTypes.object,
    selectedEbon: PropTypes.object,
    setSelectedEbon: PropTypes.func,
    error: PropTypes.string,
    setError: PropTypes.func,
    inputValue: PropTypes.string,
    setInputValue: PropTypes.func,
    disable: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.MERCHANTCARD.EBON_SELECTOR
    };
};

export default withRouter(connect(mapStateToProps)(EbonSelectorPickerComponent));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/ebonselector/EbonSelectorPickerComponent.js